import { token, host } from '../../Connnection';

export default function updateRange(dataObject) {

    fetch(`${host}/api/Websites/Status/Update`, {
        method: 'PUT',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataObject)
    })

}